import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../shared/CTAButton';
const guarantees = ['Sin experiencia previa', 'Acceso inmediato', 'Garantía de 30 días'];
const stats = [{
  value: '+3.200',
  label: 'personas transformadas'
}, {
  value: '97%',
  label: 'lo recomiendan'
}, {
  value: '6',
  label: 'módulos'
}, {
  value: '3',
  label: 'bonos de regalo'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-sand-100" data-id="element-104" data-mp="mrxy8341nsob">
      <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-forest-100/50 blur-3xl" data-id="element-105" data-mp="qub20lz8dgig" />
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 pb-16 pt-10 sm:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14 lg:pb-24 lg:pt-16" data-id="element-106" data-mp="vn45z7mvkkth">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-107" data-mp="15lbb8t7sxefn">
          <div className="inline-flex items-center gap-2 rounded-full border border-forest-100 bg-white/70 px-4 py-1.5 text-xs font-semibold tracking-tight text-forest-700" data-id="element-108" data-mp="9nj9686ww8am">
            <span aria-hidden data-id="element-109" data-mp="4qsqdd3q2yli">🧘</span> Movilidad Sin Dolor
            <span className="mx-1 text-forest-400" aria-hidden data-id="element-110" data-mp="3vw2f71fzd6tj">·</span>
            <span className="text-forest-400" data-id="element-111" data-mp="3rtxks0hpk65u">Programa 100% Online</span>
          </div>

          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-forest-800 sm:text-5xl md:text-6xl" data-id="element-112" data-mp="se0ye2sjclr8">
            Dejá de vivir con dolor todos los días.
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-forest-700/75" data-id="element-113" data-mp="io92944sfkkn">
            El método paso a paso para eliminar el dolor{' '}
            <span className="font-semibold text-forest-700" data-id="element-114" data-mp="emdzrwb4f15a">lumbar, cervical y de rodillas</span>{' '}
            con rutinas de estiramientos y movilidad que podés hacer desde tu casa, en{' '}
            <span className="font-semibold text-forest-700" data-id="element-115" data-mp="16da4uaqxw1i0">15 minutos por día</span>.
          </p>

          <div className="mt-8" data-id="element-116" data-mp="30mfjzzfhg5ic">
            <CTAButton size="lg" data-id="element-117" data-mp="30o9v6m0ycj98">QUIERO MOVERME SIN DOLOR</CTAButton>
          </div>

          <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-2" data-id="element-118" data-mp="35n38oeg8oa9e">
            {guarantees.map(g => <li key={g} className="flex items-center gap-2 text-sm font-medium text-forest-700" data-id="element-119" data-mp="2qu1eqwp74grf">
                <CheckIcon className="h-4 w-4 text-clay-500" strokeWidth={3} data-id="element-120" data-mp="2vt499n7jv4l5" />
                {g}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1],
        delay: 0.1
      }} className="relative" data-id="element-121" data-mp="2mvaguncwov39">
          <div className="overflow-hidden rounded-[2rem] border border-white/60 shadow-2xl shadow-forest-800/10" data-id="element-122" data-mp="2cyflgdbxjat7">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/21cc9071-7144-4b50-9a43-c443e310b432.jpg" alt="Persona haciendo estiramientos de movilidad en su casa, con luz natural" className="aspect-[4/5] w-full object-cover" data-id="element-123" data-mp="b4zpr20zj5rd" />
          </div>
          <div className="absolute -bottom-5 left-5 rounded-2xl border border-forest-100 bg-white px-5 py-3 shadow-xl" data-id="element-124" data-mp="25ck5amocx0mz">
            <p className="text-2xl font-bold text-forest-800" data-id="element-125" data-mp="20l2dao4baae5">15 min</p>
            <p className="text-xs font-medium text-forest-700/60" data-id="element-126" data-mp="2ed8i5e20kuya">por día, desde casa</p>
          </div>
        </motion.div>
      </div>

      <div className="border-t border-forest-100 bg-white/60" data-id="element-127" data-mp="2ab52sec8567q">
        <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-x-4 gap-y-6 px-5 py-8 sm:grid-cols-4" data-id="element-128" data-mp="2obfufjlcyoty">
          {stats.map(s => <div key={s.label} className="text-center sm:text-left" data-id="element-129" data-mp="2jdwhqo4b6k44">
              <dt className="font-display text-2xl font-semibold text-forest-800 sm:text-3xl" data-id="element-130" data-mp="tx557a0upsnn">
                {s.value}
              </dt>
              <dd className="mt-1 text-sm text-forest-700/60" data-id="element-131" data-mp="p04z4z404pwj">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </header>;
}